import { useContext } from 'react';

import { BrowserQueryCacheContext } from './query-cache-context';
import { getDefaultBrowserQueryCache, type BrowserQueryCache } from './query-cache';

export function useBrowserQueryCache(): BrowserQueryCache {
  return useContext(BrowserQueryCacheContext) ?? getDefaultBrowserQueryCache();
}
